import { Injectable, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { map, take, withLatestFrom } from 'rxjs/operators';

import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import * as fromSlotsActions from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/open-platform/slots.actions';
import { getOpenPlatformSlots } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/slots.selectors';
import { getFormsSnapshotsOpenPlatform } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/open-platform/forms-snapshots.selectors';

@Injectable()
export class ResetSlotOpenPlatformCommandService implements OnFieldChanged, OnDestroy {
  private ngDestroy = new Subject();

  constructor(private store: Store<OrderBuilderState>) {
    //
  }

  ngOnDestroy(): void {
    this.ngDestroy.next();
  }

  onFieldChanged(value: any, formGroup: UntypedFormGroup, form: ConfigurableFormComponent, config: FieldConfig): void {
    const idFormControl = formGroup.get('id');
    const formControl = formGroup.get(config.name);
    const slot$ = this.store.select(getOpenPlatformSlots).pipe(
      withLatestFrom(this.store.select(getFormsSnapshotsOpenPlatform)),
      map(([slots, snapshots]) => {
        const slot = slots[idFormControl.value];
        const recipeSnapshot = snapshots[idFormControl.value];
        if (slot && (slot.response !== null || slot.error !== null) && recipeSnapshot) {
          const snapshotFormControlValue = recipeSnapshot.values[config.name];
          if (formControl.value !== snapshotFormControlValue) {
            this.store.dispatch(new fromSlotsActions.SlotTriggerResetWarning(idFormControl.value));
          }
        }
      }),
      take(1),
    );
    if (formControl && formControl.dirty === true && config.name !== SpecFieldNames.SCHEDULE_MOMENT) {
      slot$.subscribe();
    }
  }
}
